'use strict';
var firstError = true;

var scrollAnimate = require('../components/scrollAnimate');

/**
 * Validate whole form. Requires `this` to be set to form object
 * @param {jQuery.event} event - Event to be canceled if form is invalid.
 * @param {{
*      shouldValidate: function,
*      formSubmit: boolean
* }} config - Optional configuration data
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateForm(event, config = {}) {
    var valid = true;

    if (this.checkValidity && !this.checkValidity()) {
        // safari
        if (! config.shouldValidate) valid = false;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }
        firstError = true;
        var errorFields = [];
        $(this).find('input, select, textarea:not(.g-recaptcha-response)').each(function () {
            if (config.shouldValidate && !config.shouldValidate(this)) {
                return;
            }
            if (!this.validity.valid) {
                valid = false;
                if ($(this).is('.cc-recaptcha')) {
                    $(this).siblings('.cc-feedback-message').removeClass('cc-invisible');
                }

                invalidateForm(this, event, config);

                if (config.formSubmit) {
                    for (let key in this.validity) {
                        if (this.validity[key]) {
                            var currentError = `${this.name.split('_').splice(-2).join('_')} ${key}`;
                            if (errorFields.indexOf(currentError) === -1) {
                                errorFields.push(currentError);
                            }
                        }
                    }
                }

            } else {
                if ($(this).hasClass('cc-error')) {
                    $(this).removeClass('cc-error');
                    if ($(this).hasClass('cc-select')) {
                        $(this).parent().removeClass('cc-error');
                    }
                }
                if ($(this).is('.cc-recaptcha')) {
                    $(this).siblings('.cc-feedback-message').addClass('cc-invisible');
                } else if ($(this).is('input')) {
                    $(this).siblings('.cc-feedback-message').children('.cc-text-message').text('');
                } else {
                    $(this).parent().parent().siblings('.cc-feedback-message').children('.cc-text-message').text('');
                }
            }
        });

        if (errorFields.length) {
            var $form = $(event.target);
            $(document).trigger('sendCustomError', {
                message: errorFields.join(', '),
                additionalData: {
                    type: 'validation-error',
                    category: $form.attr('data-form-name') || $form.attr('name'),
                    country: $('#currentLocale').val().split('_')[1]
                }
            });
        }
    }
    return valid;
}

/**
 * Validate form fields
 * @param {jQuery.event} event - Event to be canceled if form is invalid.
 * @param {{
 *      shouldValidate: function,
 *      formSubmit: boolean
 * }} config - Optional configuration data
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateFields(event, config) {
    var valid = true;

    if (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
    }
    firstError = true;
    var errorFields = [];
    $(this).each(function () {
        if (config && config.shouldValidate && !config.shouldValidate(this)) {
            return;
        }
        if (!this.validity.valid) {
            valid = false;
            if ($(this).is('.cc-recaptcha')) {
                $(this).siblings('.cc-feedback-message').removeClass('cc-invisible');
            }
            // invalidation also for captcha field
            $(this).trigger('invalid', {validity: this.validity, config: config});

            if (config.formSubmit) {
                for (let key in this.validity) {
                    if (this.validity[key]) {
                        var currentError = `${this.name.split('_').splice(-2).join('_')} ${key}`;
                        if (errorFields.indexOf(currentError) === -1) {
                            errorFields.push(currentError);
                        }
                        break;
                    }
                }
            }
            $(this).closest('.cc-content-input').attr('data-validation-result', 'invalid');
        } else {
            if ($(this).hasClass('cc-error')) {
                $(this).removeClass('cc-error');
                if ($(this).hasClass('cc-select')) {
                    $(this).parent().removeClass('cc-error');
                }
            }
            if ($(this).is('.cc-recaptcha')) {
                $(this).siblings('.cc-feedback-message').addClass('cc-invisible');
            } else if ($(this).is('input')) {
                $(this).siblings('.cc-feedback-message').children('.cc-text-message').text('');
            } else {
                $(this).parent().parent().siblings('.cc-feedback-message').children('.cc-text-message').text('');
            }

            $(this).closest('.cc-content-input').attr('data-validation-result', 'valid');
        }
    });

    if (errorFields.length) {
        var $form = $(this).closest('form');
        $(document).trigger('sendCustomError', {
            message: errorFields.join(', '),
            additionalData: {
                type: 'validation-error',
                category: $form.attr('data-form-name') || $form.attr('name'),
                country: $('#currentLocale').val().split('_')[1]
            }
        });
    }

    return valid;
}

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearForm(form) {
    $(form).find('.cc-input.cc-error').removeClass('cc-error');
    $(form).find('.cc-select.cc-error').removeClass('cc-error');
    $(form).find('.cc-feedback-message').children('.cc-text-message').text('');
    $('.alert', form).remove();
}
function invalidateForm (object, e, config={}) {
    if (e) e.preventDefault();
    if (!$(object).attr('data-no-oriental') === 'false') {
        object.setCustomValidity('');
    }
    if (!object.validity.valid) {
        var validationMessage = object.validationMessage;
        $(object).addClass('cc-error');
        if ($(object).hasClass('cc-select')) {
            $(object).parent().addClass('cc-error');
        }
        if (object.validity.patternMismatch && $(object).data('pattern-mismatch')) {
            validationMessage = $(object).data('pattern-mismatch');
        }
        if ($(object).attr('data-no-oriental') === 'false') {
            validationMessage = $(object).data('oriental-error');
        }
        if ((object.validity.rangeOverflow || object.validity.rangeUnderflow)
                && $(object).data('range-error')) {
            validationMessage = $(object).data('range-error');
        }
        if ((object.validity.tooLong || object.validity.tooShort)
                && $(object).data('range-error')) {
            validationMessage = $(object).data('range-error');
        }
        if (object.validity.valueMissing && $(object).data('missing-error')) {
            validationMessage = $(object).data('missing-error');
        }
        if (object.validity.typeMismatch && $(object).data('type-mismatch')) {
            validationMessage = $(object).data('type-mismatch');
        }
        if ($(object).attr('data-no-oriental') === 'false') {
            validationMessage = $(object).data('oriental-error');
        }
        $(object).parents('.cc-form-group').find('.cc-feedback-message').children('.cc-text-message')
            .eq(0).text(validationMessage);

        $(this).closest('.cc-content-input').attr('data-validation-result', '');
        
        if (firstError) {
            if (!config.skipFocus) {
                scrollAnimate($(object), {center: true, scrollableParent: config.scrollableParent});
                ($(object) || $('.logo-home')).focus();
            }
            firstError = false;
        }
    }
}
module.exports = {
    invalid: function () {
        $(document).on('invalid', 'form input, form select', function (e, data) {
            invalidateForm(this, e, data ? data.config : null);
        });
        $('.cc-next-step-button').on('click', function() {
            firstError = true;
        });
    },

    submit: function () {
        $('form').on('submit', function (e) {
            return validateForm.call(this, e, {formSubmit: true});
        });
    },

    focusOut: function () {
        $('form input:not(.js-datepicker)').on('focusout', function (event) {
            if ($(this).hasClass('js-prevent-validation')) {
                return;
            } else if (!this.validity.valid) {
                $(this).trigger('invalid', this.validity);
                invalidateForm(this, event);
            } else {
                if ($(this).hasClass('cc-error')) {
                    $(this).removeClass('cc-error');
                }
                if ($(this).is('input')) {
                    $(this).siblings('.cc-feedback-message').children('.cc-text-message').text('');
                } else {
                    $(this).parent().parent().siblings('.cc-feedback-message').children('.cc-text-message').text('');
                }
            }
        });
        $(document).on('changed.bs.select', 'select', function (event) {
            if (! $(this).val()) return;

            if (!this.validity.valid) {
                $(this).trigger('invalid', this.validity);
                invalidateForm(this, event);
            } else {
                if ($(this).hasClass('cc-error')) {
                    if ($(this).hasClass('cc-select')) {
                        $(this).parent().removeClass('cc-error');
                        $(this).removeClass('cc-error');
                    }
                }
                var found = $(this).parent().parent().children('.cc-feedback-message').children('.cc-text-message').text('').length;
                if (! found) {
                    $(this).closest('.cc-form-group').find('.cc-feedback-message .cc-text-message').text('');
                }
            }
        });
        $('input[type="radio"]').on('click change', function (event) {
            if (!this.validity.valid) {
                $(this).trigger('invalid', this.validity);
                invalidateForm(this, event);
            } else {
                if ($(this).hasClass('cc-error')) {
                    $(this).removeClass('cc-error');
                }
                $(this).closest('.d-flex').siblings('.cc-feedback-message').children('.cc-text-message').text('');
            }
        });
    },

    validateContactUsPDPform: function() {
        $(document).on('click', '#submitContactUs', function(e) {
            return validateForm.call(this.form, e);
        });
    },
    validateRequesSizePDPform: function() {
        $(document).on('click', '.js-requestsize-button', function(e) {
            if ($(this.form).find('select#requestSize-size').val() === '') {
                $(this.form).find('select#requestSize-size').each(function () {
                    var errorText = $(this).data('noitems');
                    this.setCustomValidity(errorText);
                });
            }
            return validateForm.call(this.form, e);
        });
    },
    validateFindInStorePDPform: function() {
        $(document).on('click', '.js-submit-findInStore', function(e) {
            return validateForm.call(this.form, e);
        });
    },
    validatecontactOrderform: function() {
        $(document).on('click', '.js-submit-orderInfo', function(e) {
            return validateForm.call(this.form, e);
        });
    },
    validateHelpWithSizeform: function() {
        $(document).on('click', '#helpWithSize-submit', function(e) {
            return validateForm.call(this.form, e);
        });
    },
    validateLoginOfCanvas: function() {
        $(document).on('click', 'form#loginOfCanvas .js-login-offcanvas', function(e) {
            return validateForm.call(this.form, e);
        });
    },
    validateRepairFormMyAccount: function() {
        $(document).on('click', 'form#repairForm-MyAccount .js-submit-repairForm', function(e) {
            return validateForm.call(this.form, e);
        });
    },
    validateGenericCusForm: function() {
        $(document).on('click', '.js-genericCus-submit', function(e) {
            return validateForm.call(this.form, e);
        });
    },
    validateRegistration: function() {
        $(document).on('click', 'form.registration button[type=submit]', function(e) {
            return validateForm.call(this.form, e);
        });

        $(document).on('click', 'form.registrationemail button[type=submit]', function(e) {
            return validateForm.call(this.form, e);
        });
    },
    validateOverlayNewsletter: function() {
        // clear privacy consent error message when needed
        $(document).on('click', '.js-form-overlay-newsletter .js-privacyShopping[value="true"]', function() {
            var $form = $(this.form);
            $('.js-privacy-error', $form).addClass('cc-invisible');
        });

        const isPrivacyConsentGranted = function($form) {
            var $privacyField = $('.js-privacyShopping[value="true"]', $form);
            return !! ($privacyField.length && $privacyField.is(':checked'));
        }

        const areLinesSelected = function($form) {
            var $lines = $('.cc-newsletter-form-preferences', $form);
            return !! ($lines.length && $('.cc-checkbox:checked', $lines).length);
        }


        $(document).on('click', '.js-form-overlay-newsletter button[type="submit"]', function(e){
            var $form = $(this.form);
            var $scrollableParent = $form.closest('.cc-overlay-info');

            // clear backend error messages
            $('.js-backend-errors .cc-text-message', $form).addClass('cc-invisible');
            var isFirstStep = $form.hasClass('js-form-overlay-newsletter-step1'); // this class is added only to image-two-steps modal

            // check privacy consent only if lines are selected ( only on second step with image-two-steps modal )
            if (!isFirstStep && areLinesSelected()) {
                var privacyGranted = isPrivacyConsentGranted($form);
                if (! privacyGranted) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    var $errorMsg = $('.js-privacy-error', $form);
                    $errorMsg.removeClass('cc-invisible');
                    scrollAnimate($errorMsg, {scrollableParent: $scrollableParent});
                    validateForm.call(this.form, e, {scrollableParent: $scrollableParent})
                    return false;
                }
            }

            return validateForm.call(this.form, e, {scrollableParent: $scrollableParent});
        });
    },
    validateFields: function (fields, config) {
        if (fields) {
            return validateFields.call(fields, null, config);
        }
    },
    // validateResetPwdOfCanvas: function() {
    //     $(document).on('click', 'form.cc-resetpwd-form-offCanvas .js-resetPwd-request', function(e) {
    //         return validateForm.call(this.form, e);
    //     });
    // },
    buttonClick: function () {
        $('form button[type="submit"], form input[type="submit"]').on('click', function () {
            // clear all errors when trying to submit the form
            clearForm($(this).parents('form'));
        });
    },

    noOrientalCheck: function () {
        $(document).on('focusout', '.js-no-oriental', function () {
            if ($(this).data('oriental-error') != undefined) {
                var validationMsg = $(this).data('oriental-error');
                var regex = /^[a-zA-Z0-9 -_\/(){}|"!? ’'‘ÆÐƎƏƐƔĲŊŒẞÞǷȜæðǝəɛɣĳŋœĸſßþƿȝĄƁÇĐƊĘĦĮƘŁØƠŞȘŢȚŦŲƯY̨Ƴąɓçđɗęħįƙłøơşșţțŧųưy̨ƴÁÀÂÄǍĂĀÃÅǺĄÆǼǢƁĆĊĈČÇĎḌĐƊÐÉÈĖÊËĚĔĒĘẸƎƏƐĠĜǦĞĢƔáàâäǎăāãåǻąæǽǣɓćċĉčçďḍđɗðéèėêëěĕēęẹǝəɛġĝǧğģɣĤḤĦIÍÌİÎÏǏĬĪĨĮỊĲĴĶƘĹĻŁĽĿʼNŃN̈ŇÑŅŊÓÒÔÖǑŎŌÕŐỌØǾƠŒĥḥħıíìiîïǐĭīĩįịĳĵķƙĸĺļłľŀŉńn̈ňñņŋóòôöǒŏōõőọøǿơœŔŘŖŚŜŠŞȘṢẞŤŢṬŦÞÚÙÛÜǓŬŪŨŰŮŲỤƯẂẀŴẄǷÝỲŶŸȲỸƳŹŻŽẒŕřŗſśŝšşșṣßťţṭŧþúùûüǔŭūũűůųụưẃẁŵẅƿýỳŷÿȳỹƴźżžẓ]+$/;
                var value = $(this).val();
                var valid = regex.test(value);
                if (value && value !== '') {
                    if (!valid) {
                        $(this)
                            .addClass('cc-error')
                            .siblings('.cc-feedback-message').children('.cc-text-message')
                            .text(validationMsg);
                        this.setCustomValidity(validationMsg);
                        $(this).attr('data-no-oriental', false);
                    } else {
                        if ($(this).hasClass('cc-error')) {
                            $(this)
                                .removeClass('cc-error')
                                .siblings('.cc-feedback-message').children('.cc-text-message')
                                .text('');
                            this.setCustomValidity("");
                            $(this).attr('data-no-oriental', true);
                        }
                    }
                }
            }
        });
    },
    validateRequestAppointmentform: function() {
        $(document).on('click', 'form #js-submit-Appointment', function(e) {
            e.currentTarget = $(this).closest('form#appointment');
            return validateForm.call(this.form, e);
        });
    },

    validateAppointmentformUser: function() {
        $(document).on('click', '.js-update-customerForm form .js-validate-form', function(e) {
            e.currentTarget = $(this).closest('form');
            return validateForm.call(this.form, e);
        });
    },
    functions: {
        validateForm: function (form, event) {
            validateForm.call($(form), event || null);
        },
        validateContactUsform: function() {
            var hasClassVisible = function (el) {
                return $(el).parents('.cc-no-visible').length === 0;
            }
    
            return validateForm.call($('form#contactUs').get(0), /* event = */ null, {shouldValidate: hasClassVisible});
        },
        clearForm: clearForm
    }
};
